import { render, staticRenderFns } from "./Reviewerfillratingandreview.vue?vue&type=template&id=f24e9bac&scoped=true&"
import script from "./Reviewerfillratingandreview.vue?vue&type=script&lang=ts&"
export * from "./Reviewerfillratingandreview.vue?vue&type=script&lang=ts&"
import style0 from "./Reviewerfillratingandreview.vue?vue&type=style&index=0&id=f24e9bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24e9bac",
  null
  
)

component.options.__file = "Reviewerfillratingandreview.vue"
export default component.exports